const PHRASE = "HEAVY DIESEL ENGINES  •  FORGED HYDRAULICS  •  TRACTOR TRANSMISSIONS  •  MIL-SPEC BRAKE CALIPERS  •  OEM COMPATIBLE PARTS  •  ";

export function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-amber-500/15 bg-carbon py-5" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        <span className="font-display text-2xl md:text-4xl tracking-wide text-amber-light/70 px-4">{PHRASE}</span>
        <span className="font-display text-2xl md:text-4xl tracking-wide text-amber-light/70 px-4">{PHRASE}</span>
      </div>
    </div>
  );
}
